// To prevent overlapping, make sure this is at least as big as
// the max. logo height + padding + "Expand..." link height
// 105 + 13 + 30 = 148 (ish)
var maxHeight = 200;

var $supporters = $('.supporters .supporter');

function updateBoxes() {
    $supporters
        .not('.supporter-expanded')
        .each(updateBox);
}

function updateBox() {
    var $box = $(this);

    // Reset height
    $box.css('max-height', 'none');

    // Record expanded height
    $box.data('original-height', $box.height());

    // Check if it's too tall
    if ($box.height() > maxHeight) {
        // Yes - Set a max height and display an Expand link
        $box.css('overflow', 'hidden')
            .css('max-height', maxHeight + 'px');

        if (!$box.find('.supporter-expand').length) {
            $box.append('<a href="#" class="supporter-expand">Expand...</a>')
        }
    } else {
        // No - Remove the Expand link if it's visible (in case a change in
        // window size has rendered it unnecessary)
        $box.find('.supporter-expand').remove();
    }
}

// Expand link handler
$supporters.on('click', '.supporter-expand', function (event) {
    var $box = $(this).closest('.supporter');

    // Mark it as expanded so the resize handler doesn't collapse it again
    $box.addClass('supporter-expanded');

    // Fade out the Expand link
    $box.find('.supporter-expand').fadeOut(150);

    // Expand the box
    $box.animate({
        'max-height': $box.data('original-height')
    }, 200, function () {
        $box.css('max-height', 'none');
    });

    event.preventDefault();
});

$(window).resize(updateBoxes);
updateBoxes();
